import React from 'react';
import { createRoot } from 'react-dom/client';
import WallBuilder from 'wb';
import * as Sentry from '@sentry/browser';
import { setupAnalytics } from 'arts/config/analytics';

document.addEventListener('DOMContentLoaded', () => {
  if (window.sentry_dsn) {
    Sentry.init({
      dsn: window.sentry_dsn,
      integrations: [Sentry.browserTracingIntegration],
      tracesSampleRate: 1.0
    });
    window.Sentry = Sentry;
  }
  setupAnalytics();
  const rootElement = document.getElementById('wall-builder-root');
  const root = createRoot(rootElement);
  root.render(<WallBuilder />);
});
